import { Box, Grid, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import useTitle from "hooks/useTitle";

export default function UnauthorizedPage() {
  const { formatMessage: t } = useIntl();
  useTitle(t({ id: "siteNotFoundTitle" }));

  return (
    <Grid container display="flex" justifyContent="center" textAlign="center">
      <Grid item xs={12} md={8}>
        <Box m={2}>
          <Typography variant="h6" gutterBottom>
            {t({ id: "unauthorized" })}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
